module.exports = __webpack_public_path__ + "img/home-search-bg.5fff2867.webp";